import React, { useState } from 'react';
import styles from './styles.module.scss';

import { spanish } from '../../../config/config';

const TextInput = ({
  id,
  type,
  title,
  placeholder,
  disabled,
  required,
  onChange,
  onKeyPress,
  minLength,
  maxLength,
  value,
  readOnly,
}) => {
  const errorMessage = spanish
    ? 'Este campo es requerido'
    : 'This field is required';
  const [error, setError] = useState(false);
  const validateInput = (e) => {
    if (required && e.currentTarget.value === '') setError(true);
    else setError(false);
  };
  return (
    <div className={styles.container}>
      <p className={styles.title}>{title}</p>
      <label>
        <input
          id={id}
          type={type}
          placeholder={placeholder}
          disabled={disabled}
          className={error ? 'error' : ''}
          required={required}
          onChange={onChange}
          onKeyPress={onKeyPress}
          minLength={minLength}
          maxLength={maxLength}
          onBlur={validateInput}
          value={value}
          readOnly={readOnly}
        />
      </label>
      <p className={styles.error}>{error ? errorMessage : ''}</p>
    </div>
  );
};

export default TextInput;
